var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"nav-button",attrs:{"tabindex":"0"}},[_c('div',{staticClass:"nav-button-content"},[(_vm.icon)?_c('div',{staticClass:"icon"},[_c('img',{attrs:{"src":_vm.icon,"alt":"icon"}})]):_vm._e(),_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }